import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "axios"

export const getDriversOnRoute = createAsyncThunk(
  "driversOnRoute/getDriversOnRoute",
  async (token, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_KEY}/DriverRouteSession/get_drivers_on_route`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      return data
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const driversOnRouteSlice = createSlice({
  name: "driversOnRoute",
  initialState: {
    getDriversOnRouteSuccess: false,
    getDriversOnRouteFailed: false,
    driversOnRouteList: [],
    selectedDriver: {},
  },
  reducers: {
    setSelectedDriver: (state, { payload }) => {
      state.selectedDriver = payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDriversOnRoute.pending, (state) => {
        state.getDriversOnRouteSuccess = false
        state.getDriversOnRouteFailed = false
        state.driversOnRouteList = []
      })
      .addCase(getDriversOnRoute.fulfilled, (state, { payload }) => {
        state.getDriversOnRouteSuccess = true
        state.getDriversOnRouteFailed = false
        state.driversOnRouteList = payload
      })
      .addCase(getDriversOnRoute.rejected, (state, { payload }) => {
        state.getDriversOnRouteSuccess = false
        state.getDriversOnRouteFailed = true
        state.driversOnRouteList = []
      })
  },
})

export const { setSelectedDriver } = driversOnRouteSlice.actions

export default driversOnRouteSlice.reducer
